module.exports = __webpack_public_path__ + "e593893a5916f5663dd00914f081ec6f.svg";